import R from 'ramda';
import { createSelector } from 'reselect';
import { compareJSONObjects } from '../utils';

export const selectAgreementsState = createSelector(
  (state, props) => ({
    type: props.type,
    team: state.teams.selectedTeam,
    finalizedDeals: state.deals.finalizedDeals,
    members: state.users.members,
  }),
  ({ type, team, finalizedDeals, members }) => {
    if (type === 'create') {
      const deals = [];
      if (team && members && finalizedDeals && finalizedDeals.length > 0) {
        finalizedDeals.forEach((deal) => {
          if (deal.team === team.id) {
            let teamUsers = R.pluck('user', members);
            let dealUsers = R.filter(
              (dealUser) => dealUser.type === 'member',
              deal.deal_users
            );
            dealUsers = R.pluck('user', dealUsers);

            teamUsers = R.sort((a, b) => a - b, teamUsers);
            dealUsers = R.sort((a, b) => a - b, dealUsers);
            if (compareJSONObjects(teamUsers, dealUsers)) {
              deals.push(deal);
            }
          }
        });
      }
      return deals;
    } else {
      return finalizedDeals;
    }
  }
);

export const selectDealBlocksState = createSelector(
  (state, props) => ({
    type: props.type,
    profile: state.profile,
    dealBlocks: state.dealBlocks.dealBlocks,
    dealChanges: state.deals.dealChanges,
  }),
  ({ type, profile, dealBlocks, dealChanges }) => {
    if (profile && type === 'deal-edit') {
      let blockChanges = dealBlocks ? R.clone(dealBlocks) : [];

      dealChanges.forEach((dealChange) => {
        const changes = JSON.parse(dealChange.changes);

        if (
          dealChange.user === profile.id &&
          dealChange.type === 'change-request-contract-block' &&
          changes &&
          changes.contract_block
        ) {
          let options = changes.contract_block.changes;

          if (options) {
            let index = R.findIndex(R.propEq('id', changes.contract_block.id))(
              blockChanges
            );

            if (index !== -1) {
              if (changes.contract_block.id === 0) {
                // when block is Overview
                blockChanges[index].changes = options.concat(
                  blockChanges[index].changes
                );
              } else {
                if (blockChanges[index].changes) {
                  blockChanges[index].changes = R.mergeDeepRight(
                    options,
                    blockChanges[index].changes
                  );
                }
              }
            } else {
              blockChanges.push({
                ...changes.contract_block,
              });
            }
          }
        }
      });

      return blockChanges;
    } else {
      return [];
    }
  }
);

export const selectDealsState = createSelector(
  (state, props) => ({
    deals: state.deals.deals,
    team: state.teams.selectedTeam,
    agreements: state.agreements.agreements,
  }),
  ({ deals, team, agreements }) =>
    deals.map((deal) => {
      let dealTeam, agreement;

      if (deal.team_info) {
        dealTeam = deal.team_info;
      } else if (team && deal.team === team.id) {
        dealTeam = team;
      }
      if (deal.agreement_info) {
        agreement = deal.agreement_info;
      } else {
        agreement = R.find(R.propEq('id', deal.agreement))(agreements);
      }

      return {
        ...deal,
        work_info: deal.work_info,
        team_info: dealTeam,
        agreement_info: agreement,
      };
    })
);

export const selectInvitesState = createSelector(
  (state, props) => ({
    profile: state.profile,
    invites: state.invites.invites,
    deals: state.deals.deals,
    team: state.teams.selectedTeam,
    agreements: state.agreements.agreements,
  }),
  ({ profile, deals, invites, team, agreements }) => {
    const dealInvites = [];

    invites.forEach((invite) => {
      if (profile && invite.invitee === profile.id) {
        let deal = invite.deal_info;

        if (!deal) {
          deal = R.find(R.propEq('id', invite.deal))(deals);
        }

        if (deal) {
          let dealTeam, agreement;

          if (deal.team_info) {
            dealTeam = deal.team_info;
          } else if (team && deal.team === team.id) {
            dealTeam = team;
          }
          if (deal.agreement_info) {
            agreement = deal.agreement_info;
          } else {
            agreement = R.find(R.propEq('id', deal.agreement))(agreements);
          }

          dealInvites.push({
            ...invite,
            deal_info: {
              ...deal,
              work_info: deal.work_info,
              team_info: dealTeam,
              agreement_info: agreement,
            },
          });
        }
      }
    });

    return dealInvites;
  }
);



// WEBPACK FOOTER //
// src/redux/selectors.js